import {PanelPage} from "../../PanelPage";

export class PanelCollapsed extends PanelPage {
    widthValue = 420;
    heightValue = 380;
}
